import { useEffect, useState } from "react";
import { api, imgUrl } from "../lib/api";
import { X } from "lucide-react";

const TYPES = ["all", "fabric", "print", "colorway"];

export function MaterialPicker({ value, onChange, testIdPrefix = "material-picker" }) {
  const [materials, setMaterials] = useState([]);
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    api.get("/materials").then((r) => setMaterials(r.data)).catch(() => {});
  }, []);

  if (materials.length === 0) return null;

  const filtered = filter === "all" ? materials : materials.filter((m) => m.type === filter);
  const selected = materials.find((m) => m.id === value);

  return (
    <div>
      <div className="flex items-center justify-between">
        <label className="text-xs uppercase tracking-[0.15em] text-zinc-500">Fabric / print / colorway (optional)</label>
        <div className="flex gap-1">
          {TYPES.map((t) => (
            <button key={t} data-testid={`${testIdPrefix}-filter-${t}`} onClick={() => setFilter(t)}
              className={`px-2.5 py-1 rounded text-[11px] capitalize transition-colors ${filter === t ? "bg-zinc-950 text-white" : "text-zinc-500 hover:bg-zinc-100"}`}>{t}</button>
          ))}
        </div>
      </div>
      {selected && (
        <div className="mt-2 flex items-center gap-2 border border-zinc-200 rounded-md p-2 bg-zinc-50" data-testid={`${testIdPrefix}-selected`}>
          <img src={imgUrl(selected.image_url)} alt={selected.name} className="w-8 h-8 rounded object-cover" />
          <p className="text-xs font-medium flex-1 truncate">{selected.name} <span className="text-zinc-400 font-normal capitalize">· {selected.type}</span></p>
          <button data-testid={`${testIdPrefix}-clear`} onClick={() => onChange("")} title="Remove material"
            className="p-1 rounded hover:bg-zinc-200 text-zinc-500 transition-colors"><X size={13} /></button>
        </div>
      )}
      <div className="mt-2 grid grid-cols-4 gap-2 max-h-48 overflow-y-auto pr-1">
        {filtered.map((m) => (
          <button key={m.id} data-testid={`${testIdPrefix}-swatch-${m.id}`} onClick={() => onChange(value === m.id ? "" : m.id)} title={m.name}
            className={`border rounded-md overflow-hidden transition-colors ${value === m.id ? "border-zinc-950 ring-2 ring-zinc-950" : "border-zinc-200 hover:border-zinc-400"}`}>
            <img src={imgUrl(m.image_url)} alt={m.name} className="w-full h-14 object-cover" />
            <p className="text-[10px] p-1 truncate">{m.name}</p>
          </button>
        ))}
      </div>
      <p className="text-[11px] text-zinc-400 mt-1.5">Optional — pick a swatch from your library to render the garment in that material.</p>
    </div>
  );
}
